<template>
  <div class="form-wrapper">
    <div class="form">
      <div>
        <div class="logo">
          <a href="https://easydelivery.com.br" target="_blank">
            <img src="https://cdn.easydelivery.com.br/easy_logo_pink.svg" />
          </a>
        </div>
        <div class="d-flex flex-wrap w-100 justify-center">
          <p class="welcome animated">Sucesso! Conta criada.</p>
          <p class="message line-height">
            Agora você pode configurar sua loja.
          </p>
        </div>

        <base-button
          text="Configurar loja"
          class="w-100 big mt_25"
          @click="goOnboard()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/veasy/login.css';

import BaseButton from '@/components/Button';

export default {
  components: {
    BaseButton,
  },
  methods: {
    goOnboard() {
      this.$router.push({ name: 'onboard' });
    },
  },
};
</script>
